import { useAppSelector } from "../../../lib/redux/hooks";
import { Layout } from "../../../ui/layout";
import { Banner } from "../../../ui/organisms/banner";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { Pre2015List } from "./list";

export function OldProtocol() {

    const sessionState = useAppSelector(state => state.session)

    if (sessionState.selected.customerId) {
        return (
            <Layout
                menuItem={MenuItems.PROTOCOLLO}
                breadcrumbItems={['Protocollo Pre2015']}
                noPaddingLat
                headerLabel="Protocollo Pre2015"
            >
                <div className="w-[100%] flex flex-col gap-[16px]">
                    <Pre2015List />
                </div>
            </Layout>
        )
    }

    return (
        <Layout
            menuItem={MenuItems.PROTOCOLLO}
            breadcrumbItems={['Protocollo Pre2015']}
            noPaddingLat
            headerLabel={"Protocollo Pre2015"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}